var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { bindActionCreators as originalBindActionCreator } from "redux";

var wrapAction = function wrapAction(action, reducerKey) {
  return _extends({}, action, {
    type: reducerKey + "@@" + action.type
  });
};

var wrapDispatch = function wrapDispatch(dispatch, reducerKey) {
  var wrappedDispatch = function wrappedDispatch(action) {
    var wrappedAction = void 0;
    if (typeof action === "function") {
      wrappedAction = function wrappedAction(globalDispatch, getState, extraArgument) {
        return action(wrappedDispatch, getState, function () {
          return getState()[reducerKey];
        }, globalDispatch, reducerKey, extraArgument);
      };
    } else if ((typeof action === "undefined" ? "undefined" : _typeof(action)) === "object") {
      wrappedAction = wrapAction(action, reducerKey);
    }
    return dispatch(wrappedAction);
  };
  return wrappedDispatch;
};

var bindActionCreators = function bindActionCreators(actionCreators, dispatch, reducerKey) {
  var wrappedDispatch = wrapDispatch(dispatch, reducerKey);
  return originalBindActionCreator(actionCreators, wrappedDispatch);
};

export default bindActionCreators;